import { bunja } from 'bunja';

import { walletsAtom } from './internal/fixed-topics/wallet';
import { r230522SocketBunja } from './socket';

export type * from './internal/fixed-topics/wallet';

export const walletsBunja = bunja(() => {
  bunja.use(r230522SocketBunja);
  return { walletsAtom };
});
walletsBunja.debugLabel = 'walletsBunja';
